import React, { lazy } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
export function LogoPage() {
  return <div className="min-h-screen bg-[#d9e2e8] p-2 md:p-4 font-sans selection:bg-accent selection:text-white" data-id="element-537">
      <div className="main-container max-w-[1600px] mx-auto bg-card rounded-[1.5rem] md:rounded-[2rem] border border-black/5 shadow-sm min-h-[calc(100vh-2rem)] flex flex-col" data-id="element-538">
        <Navigation activePath="/logo" data-id="element-539" />

        <main className="flex-1" data-id="element-540">
          {/* Behance-style full-width sections */}
          <section className="space-y-0" data-id="element-541">
            {/* Section 0: Hero Visual */}
            <div className="w-full overflow-hidden" data-id="element-542">
              <img src="https://cdn.magicpatterns.com/uploads/hUXdK4ZYZ3TbfVoCd1s4Pn/Headway_Purple_Bg.png" alt="Headway Tuition Logo on Purple" className="w-full h-auto block" loading="eager" data-id="element-543" />
            </div>

            {/* Section 1: Main Logo Lockups */}
            <div className="bg-white py-12 md:py-24 px-4 md:px-16 flex flex-col overflow-hidden border-b border-black/5" data-id="element-544">
              <div className="max-w-6xl w-full" data-id="element-545">
                <div className="mb-8 md:mb-12" data-id="element-546">
                  <div className="flex items-center gap-3" data-id="element-547">
                    <div className="w-2 h-2 md:w-2.5 md:h-2.5 rounded-full bg-accent" data-id="element-548" />
                    <span className="text-[10px] md:text-xs uppercase tracking-[0.2em] font-medium text-muted-foreground" data-id="element-549">
                      Visual Identity
                    </span>
                  </div>
                  <h1 className="mt-4 font-display text-2xl md:text-6xl tracking-[-0.04em] text-ink leading-tight" data-id="element-550">
                    The Logo
                    <span className="text-accent inline-block w-2 md:w-2.5 h-2 md:h-2.5 rounded-full ml-2 mb-1" data-id="element-551" />
                  </h1>
                </div>

                <div className="relative w-full overflow-hidden rounded-[0.75rem] md:rounded-[1.5rem] border border-black/5 bg-white" data-id="element-552">
                  <img src="https://cdn.magicpatterns.com/uploads/nyTVk8ho5WG3G38tEPH2Sg/Screenshot_2026-06-05_at_11.21.52.png" alt="Logo Lockups" className="w-full h-auto block" loading="lazy" data-id="element-553" />
                </div>
              </div>
            </div>

            {/* Section 3: Logo Grid/Construction */}
            <div className="bg-ink py-12 md:py-32 px-4 md:px-16 flex flex-col" data-id="element-554">
              <div className="max-w-6xl w-full space-y-6 md:space-y-12" data-id="element-555">
                <div className="text-white" data-id="element-556">
                  <h2 className="font-display text-2xl md:text-6xl tracking-[-0.02em] leading-tight" data-id="element-557">
                    Construction & <br data-id="element-558" />
                    Geometry
                  </h2>
                  <p className="mt-4 md:mt-6 text-base md:text-xl text-white/60 max-w-xl leading-relaxed" data-id="element-559">
                    Built on a precise mathematical grid, the mark combines
                    simple geometric forms to represent growth, structure, and
                    the pathway to success.
                  </p>
                </div>

                <div className="relative w-full overflow-hidden rounded-[0.75rem] md:rounded-[1.5rem] bg-white border border-white/10" data-id="element-560">
                  <img src="https://cdn.magicpatterns.com/uploads/gyuAfrEMbeKYnXdszxzNo3/Screenshot_2026-06-05_at_11.21.40.png" alt="Logo Grid" className="w-full h-auto block" loading="lazy" data-id="element-561" />
                </div>
              </div>
            </div>

            {/* Section 4: Icon */}
            <div className="bg-white py-12 md:py-32 px-4 md:px-16 flex flex-col border-b border-black/5" data-id="element-562">
              <div className="max-w-6xl w-full space-y-6 md:space-y-12" data-id="element-563">
                <div data-id="element-564">
                  <h2 className="font-display text-2xl md:text-6xl tracking-[-0.02em] text-ink leading-tight" data-id="element-565">
                    The Icon
                  </h2>
                  <p className="mt-4 md:mt-6 text-base md:text-xl text-ink/60 max-w-xl leading-relaxed" data-id="element-566">
                    A distilled version of the brand mark, optimized for
                    small-scale applications like social media avatars,
                    favicons, and app icons.
                  </p>
                </div>

                <div className="relative w-full overflow-hidden rounded-[0.75rem] md:rounded-[1.5rem] border border-black/5 bg-white" data-id="element-567">
                  <img src="https://cdn.magicpatterns.com/uploads/aYArwUnZwzzZYhsD2WFkQM/icon.png" alt="Brand Icon" className="w-full h-auto block" loading="lazy" data-id="element-568" />
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer data-id="element-569" />
      </div>
    </div>;
}